import { html, css, SoloLitElement } from '@core/solo-lit-element';
import {componentMap} from './solo-componentmap';
import config from './config/config.js';

import {initRouting} from '@bog-design-system/bd-router';
import '@bog-design-system/bd-router';

import {setMetaTags} from '@common/solo-meta-setter';
import '@common/solo-scroll-up.js';
import '@common/header/solo-header-wrapper';
import '@common/solo-research-modal-v2';
import '@common/analytics/solo-user-consent';
import '@common/seo-text-field/solo-seo-text-field';

/**
 * @customElement
 * @LitElement
 */
class SoloApp extends SoloLitElement {
    static get styles() {
        return css`
            :host {
                --content-max-width: 1296px;
                --section-space: var(--space-64);
                --border-space: var(--space-64);
                --section-title-font-size: 36px;
                --section-title-space: var(--space-48);
            }

            .content {
                display: flex;
                flex-direction: column;
                flex-grow: 1;
            }

            .overlay {
                visibility: hidden;
                transition: all 0.3s ease-in-out;
            }

            :host([overlay]) .overlay {
                visibility: visible;
                position: fixed;
                z-index: 3;
                background-color: var(--color-overlay);
                width: 100vw;
                height: 100vh;
                transition: all 0.3s ease-in-out;
            }

            .page-component[ready] {
                animation-name: fade-in;
                animation-duration: 1000ms;
                animation-timing-function: ease-in-out;
            }

            .page-component[hidden] {
                opacity: 0;
            }

            .buttons {
                position: fixed;
                display: flex;
                flex-direction: column;
                right: 53px;
                bottom: 86px;
                z-index: 8;
              }
      

            .hidden {
                display: none;
            }
            
            .research {
                z-index: 1000;
                margin-top: var(--space-4);
            }
      
            .scroll {
                align-self: flex-end;
            }
      
            @media(max-width: 1024px) {
                :host {
                    --border-space: var(--space-48);
                    --section-space: var(--space-48);
                }
            }

            @media(max-width: 768px) {
                :host {
                    --section-space: var(--space-32);
                    --border-space: var(--space-24);
                    --section-title-space: var(--space-32);
                }
            }

            @media(max-width: 600px) {
                :host {
                    --section-space: var(--space-24);
                    --border-space: var(--space-24);
                    --section-title-font-size: 24px;
                }

                .solo {
                  padding-top: var(--space-64);
                }
            }

            @keyframes fade-in {
                0% {
                    opacity: 0;
                }

                100% {
                    opacity: 1;
                }
            }
            .chat {
                position: fixed;
                bottom: var(--space-16);
                right: 30px;
                z-index: calc(var(--overlay-z-index));
                transition: right 200ms ease-in-out;
            }

            .chat-up {
                z-index: calc(var(--overlay-z-index) + 1);
            }

            @media (max-width: 375px) {
                .chat {
                    right: 0px !important;
                    bottom: 0px;
                }
              
                .buttons {
                    right: var(--space-24)
                  }
      
            }
            @media (max-width: 425px) {
                .chat {
                    right: 0px;
                }
              
                .buttons {
                    right: var(--space-24)
                  }
      
            }
        `;
    }
    render() {
        return html` 
            <bd-router route="${this.route}"
                path="/${this.lang}"
                pattern="/:segment/:endpoint/:tail">
            </bd-router>
            <div class="overlay"></div>
            <div class="solo" id="main">
                <solo-header-wrapper
                    id="header" class="hidden"
                    route="${this.route}"
                    .pathEndpoints="${{items: this.pathEndpoints}}"
                    ?hide-header="${this.hideHeader}"
                    @logout="${this._logout}">
                </solo-header-wrapper>
                
                <div id="content" class="content"></div>
                <div class="buttons" id="buttons">
                    <solo-scroll-up class="scroll"></solo-scroll-up>
                    <solo-research-modal-v2 class="research"></solo-research-modal-v2>
                    <solo-user-consent id="consent"></solo-user-consent>
                </div>
                <solo-footer class="hidden" id="footer"></solo-footer>
            </div>
        `;
    }

    static get properties() {
        return {
            tree: {
                type: Object,
            },
            route: {
                type: String,
            },
            pathEndpoints: {
                type: Array,
            },
            overlay: {
                type: Boolean,
                reflect: true,
            },
            pathEndpointsTriggered: {
              type: Boolean,
            },
            hideHeader: {
              type: Boolean,
              reflect: true,
              attribute: 'hide-header',
            },
        };
    }

    constructor() {
        super();
        this.pathEndpointsTriggered = false;
        this.searchEngines = ['google', 'bing', 'yahoo', 'baidu', 'yandex',
          'duckduckgo', 'sogou', 'ecosia', 'shenma', 'mail.ru'];
        setTimeout(() => {
            import('@common/solo-chat-button').then(() => {
                const button = document.createElement('solo-chat-button');
                button.setAttribute('id', 'chat');
                button.classList.add('chat');
                this.$.buttons.appendChild(button);
            });
        }, 500);
        this._loadSearchParams();
        this._initRouteChangeListener();
    }

    createUtmObject(url) {
        const currentDay = new Date();
        window._urlSearchParams = url.searchParams;
        const utmSource = window._urlSearchParams.get('utm_source');
        const utmMedium = window._urlSearchParams.get('utm_medium');
        const utmCampaign = window._urlSearchParams.get('utm_campaign');
        const utmId = window._urlSearchParams.get('utm_id');
        const utmTerm = window._urlSearchParams.get('utm_term');
        const utmContent = window._urlSearchParams.get('utm_content');

        const utm = {
            utmSource,
            utmMedium,
            utmCampaign,
            utmId,
            utmTerm,
            utmContent,
        };
        const obj = {
        date: currentDay,
        utm: utm,
        };
        localStorage.setItem('utm_params', JSON.stringify(obj));
    }

    setUtm() {
        window._urlSearchParams = new URLSearchParams();

        window._urlSearchParams.set('utm_source', JSON.parse(localStorage.getItem('utm_params')).utm.utmSource) || null;
        window._urlSearchParams.set('utm_medium', JSON.parse(localStorage.getItem('utm_params')).utm.utmMedium || null);
        window._urlSearchParams.set('utm_campaign',
            JSON.parse(localStorage.getItem('utm_params')).utm.utmCampaign || null);
        window._urlSearchParams.set('utm_id', JSON.parse(localStorage.getItem('utm_params')).utm.utmId || null);
        window._urlSearchParams.set('utm_term', JSON.parse(localStorage.getItem('utm_params')).utm.utmTerm || null);
        window._urlSearchParams.set('utm_content',
          JSON.parse(localStorage.getItem('utm_params')).utm.utmContent || null);

        let referrer = document.referrer.toLowerCase();
        referrer = referrer.substring(referrer.indexOf('//') + 2);

        const isOrganic = this.searchEngines.some((item) => {
        return referrer.includes(item);
        });

        if (!window._urlSearchParams.get('utm_source')) {
        if (!referrer) {
            window._urlSearchParams.set('utm_source', 'direct');
        } else if (!isOrganic) {
            window._urlSearchParams.set('utm_source', referrer);
        } else {
            window._urlSearchParams.set('utm_source', 'organic_search');
        }
        }
    }

    _setUtmData(url) {
        const currentDay = new Date();
        const params = JSON.parse(localStorage.getItem('utm_params'));
        const date = params.date;

        if (currentDay - 30*24*60*60*1000 > new Date(date).getTime()) {
        this.createUtmObject();
        } else {
        window._urlSearchParams = url.searchParams;
        if (window._urlSearchParams.get('utm_source') !== null || window._urlSearchParams.get('utm_medium') !== null ||
        window._urlSearchParams.get('utm_campaign') !== null
        ) {
            this.createUtmObject(url);
        }
        this.setUtm();
        }
    }

    _loadSearchParams() {
        const url = new URL(window.location.href);
        try {
        this._setUtmData(url);
        } catch {
        window._urlSearchParams = new URLSearchParams();
        this.createUtmObject(url);
        this.setUtm();
        }
    }

    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('bd-drawer-open', this._drawerOpened.bind(this));
        window.addEventListener('bd-drawer-close', this._drawerClosed.bind(this));

        const sdk = document.createElement('script');
        sdk.src = config.ssoSdkUrl;
        document.head.appendChild(sdk);

        if (this.isMobile) {
          let lastScrollTop = 0;
          window.addEventListener('scroll', () => {
            const currentScrollTop = document.documentElement.scrollTop;
            if (currentScrollTop <= 64) {
              this.hideHeader = false;
            } else if (currentScrollTop > lastScrollTop) {
              this.hideHeader = true;
            } else {
              this.hideHeader = false;
            }
            lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // For Mobile or negative scrolling
          });
        }

        // TODO NEED FIX !!!!! (☞ﾟヮﾟ)☞
        let location = window.location.href;
        location = location.slice(location.indexOf('/en'));

        let errorStr = '/en/solo/main/become-solo-foreign?utm_source=biltmore&utm_medium=qr-banner&';
        errorStr += 'https://solo.ge/en/solo/main/become-solo-foreign?utm_source=borjomi_likani&utm_medium=qr-banner&';
        errorStr += 'utm_campaign=become-solo-international=become-solo-international';

        if (location === errorStr) {
            // eslint-disable-next-line max-len
            window.location.href = '/en/solo/main/become-solo-foreign?utm_source=borjomi_likani&utm_medium=qr-banner&utm_campaign=become-solo-international';
        }
        this._initSentry();
    }

    _getCleanPath(newRoute) {
        let path = newRoute;
        if (path[path.length - 1] === '/') {
          path = path.slice(0, -1);
        }
        return path;
      }

    async getTree() {
        let treeCache = JSON.parse(localStorage.getItem('tree'));
        if (!treeCache) {
            treeCache = {};
        }
        let checksum = treeCache.checksum ? treeCache.checksum : null;
        let res = await this.apiCall('tree/getTree', 'POST', {checksum: checksum});
        if (res.json) {
            localStorage.setItem('tree', JSON.stringify(res.json));
            this.tree = res.json;
        } else {
            this.tree = treeCache;
        }
    }

    async _routeChanged(newRoute) {
        const _newRoute = newRoute.split('#');
        let path = this._getCleanPath(_newRoute[0]);
        let params = path.split('/');
        if (!this._setLang(params[1])) {
            return;
        }
        if (!this.tree) {
            await this.getTree();
        }
        params.splice(1, 1);

        if (params[params.length - 1].includes('?')) {
            const index = params[params.length - 1].indexOf('?');
            const prev = params[params.length - 1];
            params[params.length - 1] = prev.substring(0, index);

            if (params[params.length - 1] === '') {
                params.pop();
            }
        }

        let node = this._findNode(params);
        this._renderPage(node);
    }

    get queryParams() {
        const search = location.search.substring(1);
        if (!search || /^\s*$/.test(search)) return {};

        const ret = '{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}';

        return JSON.parse(
            ret
                .replace(/\,\"\"\,/g, ',')
                .replace(/\,\"\"\}/g, '}')
                .replace(/\{\"\"\,/g, '{'),
        );
    }

    _findNode(path) {
        if (!path.length) {
            return this.tree.childs[0];
        }
        let curNode = this.tree;
        let curPath = '/' + this.lang;
        let curPathEndpoints = [];
        for (let i = 0; i < path.length; i++) {
            let found = false;
            for (let node of curNode.childs) {
                if (node.endPoint === path[i]) {
                    found = true;
                    curNode = node;
                    node.params = null; // reset params
                    curPath += node.endPoint + '/';
                    if (i > 0) {
                        curPathEndpoints.push({
                            name: node[this.lang].name,
                            link: curPath,
                        });
                    }
                    break;
                }
            }

            if (!found && !componentMap[curNode.contentType].hasParams) {
                this.pathEndpoints = curPathEndpoints;
                return null;
            }
            if (!found && componentMap[curNode.contentType].hasParams) {
                this.pathEndpoints = curPathEndpoints;
                curNode.params = path.slice(i);
                break;
            }
        }
        curNode.queryParams = this.queryParams;
        this.pathEndpoints = curPathEndpoints;
        return curNode;
    }

    _renderPage(node) {
        let allowCanonical = true;
        if (!node || !componentMap[node.contentType]) {
            node = this._findNode(['', '404']);
            allowCanonical = false;
        }

        if (!componentMap[node.contentType].hideHeader) {
            import('@common/header/solo-header-wrapper.js').then(() => {
                this.$.header.classList.remove('hidden');
            });
        }

        if (node[this.lang].url) {
            window.location.replace(node[this.lang].url);
            return;
        }
        this.$.footer.classList.add('hidden');
        window.scrollTo({
            top: 0,
        });
        setMetaTags(node, this.lang);


        if (allowCanonical) {
          this._generateCanonicalUrl(node[this.lang]);
          this._generateAlternates(node, this.lang);
        } else {
          const elem = document.querySelector('link[rel=canonical]');
          if (elem) {
            elem.remove();
          }
        }

        this.$.content.innerHTML = '';
        componentMap[node.contentType].action()
            .then(() => {
                let element = document.createElement(componentMap[node.contentType].name);
                element.classList.add('page-component');
                element.ref = node[this.lang].content;
                if (node.params) {
                    for (let i = 0; i < node.params.length; i++) {
                        node.params[i] = decodeURI(node.params[i]);
                    }
                    element.params = node.params;
                }
                if (node.queryParams) {
                    element.queryParams = node.queryParams;
                }
                this.$.content.innerHTML = '';
                this.$.content.appendChild(element);
                this._loadTheme();
                this._renderSeoTextField(node[this.lang].content);
                if (!componentMap[node.contentType].hideFooter) {
                    import('@common/footer/solo-footer.js').then(() => {
                        window.dispatchEvent(
                            new CustomEvent('footer-ready', {
                                bubbles: true,
                            }),
                        );
                        this.$.footer.classList.remove('hidden');
                    });
                }
            })
            .catch(() => {
                this._renderPage(this._findNode(['', '404']));
            });
    }

    _setLang(lang) {
        const currLang = lang?.toLowerCase() || localStorage.getItem('lang') || 'ka';
        if (!config.languages.includes(currLang)) {
            this.lang = 'ka';
            window.location.replace(encodeURI('/ka/solo/404'));
            return false;
        } else {
            this.lang = currLang;
        }
        localStorage.setItem('lang', this.lang);
        localStorage.setItem('language', this.lang);
        return true;
    }

    _loadTheme() {
        document.body.classList.remove('dark');
        document.body.classList.add('solo');
        sessionStorage.setItem('theme', 'solo');
    }

    _logout() {
        localStorage.removeItem('loggedIn');
        localStorage.removeItem('userInfo');
        this.apiCall('auth/logout')
            .then((res) => {
                location.href = res.json.logoutUrl;
            })
            .catch((err) => console.log(err));
    }

    _generateCanonicalUrl(node) {
      const elem = document.querySelector('link[rel=canonical]');
      if (elem) {
        const url = node.canonical_url ? node.canonical_url : window.location.origin + window.location.pathname;
        elem.setAttribute('href', encodeURI(url));
      }
    }

    _generateAlternates(node, lang) {
      const items = document.querySelectorAll(`link[rel="alternate"]`);
      items.forEach((item) => {
        const currUrl = node[lang].url || window.location.href;
        if (item.hreflang === lang) {
          item.href = currUrl;
        } else {
          const altLang = lang === 'ka' ? 'en' : 'ka';
          item.href = node[altLang].alternative_url ? node[altLang].alternative_url :
            currUrl.replace(`/${lang}/`, lang === 'ka' ? '/en/' : '/ka/');
        }
      });
    }

    _drawerOpened(e) {
        const eventPath = e.path || (e?.composedPath && e?.composedPath());
        let width = eventPath[0].firstElementChild.offsetWidth;
        if (window.innerWidth - width - 10 > 320) {
            this.shadowRoot.querySelector('#chat').style.right = `${width + 10}px`;
            this.shadowRoot.querySelector('#chat').classList.add('chat-up');
        }
    }

    _drawerClosed() {
        this.shadowRoot.querySelector('#chat').style.right = '30px';
        this.shadowRoot.querySelector('#chat').classList.remove('chat-up');
    }

    _initRouteChangeListener() {
        window.addEventListener('bd-router-updated', (event) => {
            const route = event.detail.pathname;
            this.route = route;
            this._routeChanged(route);
        });

        initRouting(true);
      }
    _initSentry() {
        if (config?.sentryDSN) {
            import('@sentry/browser').then((Sentry) => {
                Sentry.init({
                    environment: 'PRODUCTION',
                    dsn: config.sentryDSN,
                    release: window.appVersion || 'latest',
                    integrations: [
                        new Sentry.browserTracingIntegration(),
                        new Sentry.globalHandlersIntegration({
                            onunhandledrejection: false,
                        }),
                        Sentry.browserApiErrorsIntegration({
                            eventTarget: false,
                        }),
                    ],
                    attachStacktrace: true,
                    tracesSampleRate: 0.2,
                    ignoreUrls: [/node_modules\//],
                });
            });
        }
    }

    _renderSeoTextField(ref) {
        const element = document.createElement('solo-seo-text-field');
        element.ref = ref;
        this.$.content.appendChild(element);
    }
}

window.customElements.define('solo-app', SoloApp);
